/*#__PURE__*/ export default JSON.parse('{"key":"balances","type":"root","items":[{"key":"pollingInterval","def":60,"type":"int"}]}');